"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NftLoader = void 0;
exports.addTokenURIs = addTokenURIs;
exports.nftUriToUrl = nftUriToUrl;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _cache = require("@blockwell/cache");
var _chains = require("@blockwell/chains");
var _nftAbi = require("./nft-abi");
const INTERFACE_ID_ERC721_ENUMERABLE = "0x780e9d63";
const ipfsRegex = /^https:\/\/ipfs.io\/ipfs/i;
function nftUriToUrl(uri) {
  if (uri.startsWith("ipfs://")) {
    return "https://cloudflare-ipfs.com/ipfs/" + uri.slice(7);
  } else if (ipfsRegex.test(uri)) {
    return uri.replace(ipfsRegex, "https://cloudflare-ipfs.com/ipfs");
  } else {
    return uri;
  }
}
class NftLoader {
  constructor(cache, client) {
    (0, _defineProperty2.default)(this, "fastCache", new _cache.SyncMemoryCache(5 * 60 * 1000));
    (0, _defineProperty2.default)(this, "addTokenURIs", addTokenURIs);
    this.cache = cache;
    this.client = client;
  }
  async getToken(batches, contract, tokenId) {
    var _this$fastCache$getIt;
    let key = contract.id + "-" + tokenId;
    let item = (_this$fastCache$getIt = this.fastCache.getItem(key)) === null || _this$fastCache$getIt === void 0 ? void 0 : _this$fastCache$getIt.data;
    if (!item) {
      let {
        tokenURI
      } = await batches.batch(contract.network).setContract(_nftAbi.nftAbi, contract.address).try("tokenURI", false, [tokenId]).execute();
      item = await this.loadMetadata(tokenURI);
      this.fastCache.setItem(key, item);
    }
    return item;
  }
  loadMetadata(uri) {
    if (!uri) {
      return Promise.resolve(null);
    }
    return this.cache.withCache(uri, async () => {
      let url = nftUriToUrl(uri);
      let metadata = (await this.client.get(url)).data;
      if (metadata !== null && metadata !== void 0 && metadata.image) {
        metadata.image = nftUriToUrl(metadata.image);
      }
      return metadata;
    }, uri, 5 * 60 * 1000);
  }
  async getItems(batches, contract, account, clearCache = false) {
    let key = contract.id + "-" + account;
    return this.cache.withCache(key, async () => {
      let net = (0, _chains.getChain)(contract.network);
      let {
        enumerable,
        balance
      } = await batches.batch(net).setContract(_nftAbi.nftAbi, contract.address).tryInt("balanceOf", "balance", [account]).addBoolean("supportsInterface", "enumerable", [INTERFACE_ID_ERC721_ENUMERABLE], null, 24 * 60 * 60 * 1000).execute();
      let tokenIds;
      if (enumerable) {
        tokenIds = await this.getItemsEnumerable(batches, contract, account, balance);
      } else {
        tokenIds = await this.getItemsEvents(batches, contract, account);
      }
      let items = tokenIds.map(it => {
        return {
          tokenId: it,
          chainId: net.chainId,
          nft: contract.address
        };
      });
      await addTokenURIs(batches, items);
      return items;
    }, key, clearCache ? 1 : undefined);
  }
  async getItemsEnumerable(batches, contract, account, balance) {
    if (balance > 0) {
      let res = await batches.batch(contract.network).setContract(_nftAbi.nftAbi, contract.address).addList("tokenOfOwnerByIndex", "tokenIds", balance, {
        args: [account, true]
      }).execute();
      return res.tokenIds;
    }
    return [];
  }
  async getItemsEvents(batches, contract, account) {
    const client = batches.client;
    let [to, from] = await Promise.all([client.events(contract.network, contract.address, _nftAbi.nftAbi, "Transfer", [account]), client.events(contract.network, contract.address, _nftAbi.nftAbi, "Transfer", [null, account])]);
    let events = to.concat(from).sort((a, b) => a.blockNumber - b.blockNumber);
    let tokenIds = new Set();
    for (let event of events) {
      if ((0, _chains.addressEqual)(event.args._to, account)) {
        let id = event.args._tokenId.toString();
        tokenIds.add(id);
      } else {
        let id = event.args._tokenId.toString();
        tokenIds.delete(id);
      }
    }
    return Array.from(tokenIds);
  }
}
exports.NftLoader = NftLoader;
async function addTokenURIs(batches, allItems) {
  let chains = {};
  for (let it of allItems) {
    if (!chains[it.chainId]) {
      chains[it.chainId] = {};
    }
    if (!chains[it.chainId][it.nft]) {
      chains[it.chainId][it.nft] = [];
    }
    chains[it.chainId][it.nft].push(it);
  }
  await Promise.all(Object.entries(chains).map(([chainId, contracts]) => {
    let batch = batches.batch(chainId);
    for (let [address, items] of Object.entries(contracts)) {
      batch.setContract(_nftAbi.nftAbi, address).addListConvert("tokenURI", (value, index) => {
        items[index].uri = value.toString();
        return value;
      }, address, items.length, {
        argsList: items.map(it => [it.tokenId])
      });
    }
    return batch.execute();
  }));
}
//# sourceMappingURL=NftLoader.js.map